import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Grid,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  Badge,
  Icon,
  Circle,
  useColorModeValue,
  useColorMode,
  useDisclosure,
  List,
  ListItem,
  ListIcon,
  Divider,
  Container,
  Image,
} from "@chakra-ui/react";
import {
  FaCheck,
  FaTimes,
  FaUsers,
  FaCloud,
  FaClipboardCheck,
  FaPlug,
  FaShieldAlt,
  FaRocket,
  FaChartLine,
  FaCrown,
  FaInfinity,
  FaCalendarDay,
  FaFileInvoiceDollar,
  FaGraduationCap,
  FaMobileAlt,
  FaRobot,
  FaHeadset,
  FaLock,
  FaDatabase,
  FaGlobe,
  FaBars,
  FaTimes as FaTimesIcon,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ContactFormModal from "./components/ContactFormModal";

const Navbar = ({ onContactClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn(`Section with id "${sectionId}" not found`);
    }
  };

  return (
    <Box
      position="sticky"
      top="0"
      zIndex="1000"
      bg="rgba(255, 255, 255, 0.98)"
      backdropFilter="blur(20px)"
      boxShadow="0 2px 12px rgba(0, 0, 0, 0.06)"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      <Container maxW="container.xl">
        <Flex justify="space-between" align="center" py={3}>
          <HStack
            spacing={2}
            cursor="pointer"
            onClick={() => (window.location.href = "/")}
            transition="all 0.2s"
            _hover={{ opacity: 0.8 }}
          >
                onClick={() => navigate("/login")}
              src="/image.png"
              alt="NoraHuman"
              boxSize="48px"
              transition="all 0.2s"
            />
            <Heading
              size="md"
              bgGradient="linear(to-r, gray.900, purple.700)"
              bgClip="text"
              fontWeight="800"
              letterSpacing="tight"
            >
              NoraHuman
            </Heading>
          </HStack>

          <HStack spacing={8} display={{ base: "none", md: "flex" }}>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              position="relative"
              py={2}
              px={3}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
              }}
              _after={{
                content: '""',
                position: "absolute",
                bottom: "0",
                left: "50%",
                transform: "translateX(-50%)",
                width: "0%",
                height: "3px",
                bgGradient: "linear(to-r, purple.500, purple.600)",
                borderRadius: "2px 2px 0 0",
                transition: "width 0.2s ease-out",
              }}
              sx={{
                "&:hover::after": {
                  width: "80%",
                },
              }}
              onClick={() => handleScroll("pricing")}
            >
              Pricing
            </Text>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              position="relative"
              py={2}
                onClick={() => navigate("/login")}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
              }}
              _after={{
                content: '""',
                position: "absolute",
                bottom: "0",
                left: "50%",
                transform: "translateX(-50%)",
                width: "0%",
                height: "3px",
                bgGradient: "linear(to-r, purple.500, purple.600)",
                borderRadius: "2px 2px 0 0",
                transition: "width 0.2s ease-out",
              }}
              sx={{
                "&:hover::after": {
                  width: "80%",
                },
              }}
              onClick={() => handleScroll("features")}
            >
              Features
            </Text>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              position="relative"
              py={2}
              px={3}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
              }}
              _after={{
                content: '""',
                position: "absolute",
                bottom: "0",
                left: "50%",
                transform: "translateX(-50%)",
                width: "0%",
                height: "3px",
                bgGradient: "linear(to-r, purple.500, purple.600)",
                borderRadius: "2px 2px 0 0",
                transition: "width 0.2s ease-out",
              }}
              sx={{
                "&:hover::after": {
                  width: "80%",
                },
              }}
              onClick={() => handleScroll("enterprise")}
            >
              Enterprise
            </Text>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              position="relative"
              py={2}
              px={3}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
              }}
              _after={{
                content: '""',
                position: "absolute",
                bottom: "0",
                left: "50%",
                transform: "translateX(-50%)",
                width: "0%",
                height: "3px",
                bgGradient: "linear(to-r, purple.500, purple.600)",
                borderRadius: "2px 2px 0 0",
                transition: "width 0.2s ease-out",
              }}
              sx={{
                "&:hover::after": {
                  width: "80%",
                },
              }}
              onClick={onContactClick}
            >
              Contact
            </Text>
          </HStack>

          <HStack spacing={3} display={{ base: "none", md: "flex" }}>
            <Button
              variant="ghost"
              onClick={() => (window.location.href = "/login")}
              fontWeight="600"
              fontSize="sm"
              px={5}
              h="38px"
              color="gray.700"
              _hover={{
                bg: "gray.100",
                color: "gray.900",
              }}
              transition="all 0.2s"
            >
              Sign In
            </Button>
            <Button
              bgGradient="linear(to-r, purple.600, purple.700)"
              color="white"
              onClick={() => (window.location.href = "/login")}
              fontWeight="700"
              fontSize="sm"
              px={6}
              h="38px"
              boxShadow="0 2px 8px rgba(124, 58, 237, 0.25)"
              _hover={{
                bgGradient: "linear(to-r, purple.700, purple.800)",
                boxShadow: "0 4px 12px rgba(124, 58, 237, 0.35)",
                transform: "translateY(-1px)",
              }}
              _active={{
                transform: "translateY(0)",
              }}
              transition="all 0.2s"
            >
              Get Started
            </Button>
          </HStack>

          <Icon
            as={isOpen ? FaTimesIcon : FaBars}
            boxSize={5}
            color="gray.700"
            cursor="pointer"
            display={{ base: "block", md: "none" }}
            onClick={() => setIsOpen(!isOpen)}
            transition="all 0.2s"
            _hover={{
              color: "purple.600",
            }}
            _active={{
              transform: "scale(0.95)",
            }}
          />
        </Flex>

        {isOpen && (
          <VStack
            spacing={0}
            align="stretch"
            pb={4}
            display={{ base: "flex", md: "none" }}
            borderTop="1px solid"
            borderColor="gray.200"
            bg="white"
          >
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              py={3}
              px={4}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
                bg: "purple.50",
              }}
              _active={{
                bg: "purple.100",
              }}
              onClick={() => {
                handleScroll("pricing");
                setIsOpen(false);
              }}
            >
              Pricing
            </Text>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              py={3}
              px={4}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
                bg: "purple.50",
              }}
              _active={{
                bg: "purple.100",
              }}
              onClick={() => {
                handleScroll("features");
                setIsOpen(false);
              }}
            >
              Features
            </Text>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              py={3}
              px={4}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
                bg: "purple.50",
              }}
              _active={{
                bg: "purple.100",
              }}
              onClick={() => {
                handleScroll("enterprise");
                setIsOpen(false);
              }}
            >
              Enterprise
            </Text>
            <Text
              fontSize="sm"
              fontWeight="600"
              color="gray.800"
              cursor="pointer"
              py={3}
              px={4}
              mb={2}
              transition="all 0.2s"
              _hover={{
                color: "purple.600",
                bg: "purple.50",
              }}
              _active={{
                bg: "purple.100",
              }}
              onClick={() => {
                onContactClick();
                setIsOpen(false);
              }}
            >
              Contact
            </Text>
            <Divider />
            <HStack spacing={2} px={4} pt={4}>
              <Button
                variant="ghost"
                flex={1}
                fontWeight="600"
                fontSize="sm"
                h="40px"
                color="gray.700"
                onClick={() => {
                  window.location.href = "/login";
                }}
                _hover={{
                  bg: "gray.100",
                  color: "gray.900",
                }}
                transition="all 0.2s"
              >
                Sign In
              </Button>
              <Button
                bgGradient="linear(to-r, purple.600, purple.700)"
                color="white"
                flex={1}
                fontWeight="700"
                fontSize="sm"
                h="40px"
                boxShadow="0 2px 8px rgba(124, 58, 237, 0.25)"
                onClick={() => {
                  window.location.href = "/login";
                }}
                _hover={{
                  bgGradient: "linear(to-r, purple.700, purple.800)",
                  boxShadow: "0 4px 12px rgba(124, 58, 237, 0.35)",
                }}
                _active={{
                  transform: "scale(0.98)",
                }}
                transition="all 0.2s"
              >
                Get Started
              </Button>
            </HStack>
          </VStack>
        )}
      </Container>
    </Box>
  );
};

const FeatureCard = ({ icon, title, description, color, comingSoon }) => {
  return (
    <Box
      bg="white"
      p={6}
      rounded="xl"
      border="2px solid"
      borderColor="gray.100"
      transition="all 0.3s"
      position="relative"
      overflow="hidden"
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "4px",
        bgGradient: `linear(to-r, ${color}.400, ${color}.600)`,
        opacity: 0,
        transition: "opacity 0.3s",
      }}
      _hover={{
        shadow: "xl",
        borderColor: `${color}.200`,
        transform: "translateY(-8px)",
        _before: { opacity: 1 },
      }}
    >
      <VStack spacing={4} align="center" textAlign="center">
        <Box position="relative">
          <Circle size="60px" bg={`${color}.50`} color={`${color}.600`}>
            <Icon as={icon} boxSize={7} />
          </Circle>
          {comingSoon && (
            <Badge
              position="absolute"
              top="-2"
              right="-2"
              colorScheme="yellow"
              fontSize="xx-small"
              px={2}
              py={1}
              borderRadius="md"
            >
              Soon
            </Badge>
          )}
        </Box>
        <Heading size="sm" color="gray.800" fontWeight="600">
          {title}
        </Heading>
        <Text fontSize="sm" color="gray.600" lineHeight="1.6">
          {description}
        </Text>
      </VStack>
    </Box>
  );
};

const PricingCard = ({
  name,
  price,
  period,
  perUser,
  description,
  subtitle,
  features,
  icon,
  color,
  popular,
  buttonText,
  onSelect,
}) => {
  return (
    <Box
      bg={popular ? "white" : "white"}
      bgGradient={popular ? "linear(to-b, purple.50, white)" : "none"}
      p={8}
      rounded="2xl"
      border={popular ? "3px solid" : "2px solid"}
      borderColor={popular ? `purple.400` : "gray.200"}
      position="relative"
      shadow={popular ? "2xl" : "lg"}
      transition="all 0.3s"
      transform={popular ? "scale(1.05)" : "scale(1)"}
      _hover={{
        shadow: "2xl",
        borderColor: `${color}.400`,
        transform: popular ? "scale(1.08)" : "scale(1.03)",
      }}
    >
      {popular && (
        <Badge
          position="absolute"
          top="-4"
          right="6"
          bgGradient="linear(to-r, purple.500, purple.600)"
          color="white"
          px={4}
          py={2}
          borderRadius="full"
          fontSize="xs"
          fontWeight="700"
          textTransform="uppercase"
          letterSpacing="wider"
          boxShadow="lg"
        >
          Recommended
        </Badge>
      )}

      <VStack spacing={4} align="stretch">
        <Flex align="center" gap={3}>
          <Circle size="50px" bg={`${color}.50`} color={`${color}.600`}>
            <Icon as={icon} boxSize={6} />
          </Circle>
          <Box>
            <Heading size="md" color="gray.800" fontWeight="700">
              {name}
            </Heading>
            <Text fontSize="sm" color="gray.600">
              {description}
            </Text>
          </Box>
        </Flex>

        <Text fontSize="xs" color="gray.600" fontStyle="italic" lineHeight="1.5">
          {subtitle}
        </Text>

        <Divider />

        <Box textAlign="center" py={4}>
          <Text
            fontSize="5xl"
            fontWeight="extrabold"
            bgGradient={`linear(to-r, ${color}.500, ${color}.700)`}
            bgClip="text"
          >
            {price}
          </Text>
          <Text fontSize="sm" color="gray.600" mt={-2}>
            {period}
          </Text>
          {perUser && (
            <Text fontSize="xs" color="gray.600" mt={2} fontStyle="italic">
              {perUser}
            </Text>
          )}
          <Text fontSize="2xs" color="gray.500" mt={1}>
            Average client saves ₹1.2L annually in HR overhead
          </Text>
        </Box>

        <Button
          bgGradient={
            popular ? `linear(to-r, ${color}.500, ${color}.600)` : "none"
          }
          colorScheme={color}
          size="lg"
          w="100%"
          onClick={onSelect}
          variant={popular ? "solid" : "outline"}
          fontWeight="700"
          color={popular ? "white" : undefined}
          _hover={{
            transform: "translateY(-2px)",
            boxShadow: "xl",
            bgGradient: popular
              ? `linear(to-r, ${color}.600, ${color}.700)`
              : undefined,
          }}
          transition="all 0.3s"
        >
          {buttonText}
        </Button>

        <Divider />

        <List spacing={3}>
          {features.map((feature, idx) => (
            <ListItem key={idx} display="flex" alignItems="flex-start">
              <ListIcon
                as={feature.included ? FaCheck : FaTimes}
                color={feature.included ? `${color}.500` : "gray.400"}
                mt={1}
              />
              <Text
                fontSize="sm"
                color={feature.included ? "gray.700" : "gray.400"}
                flex={1}
              >
                {feature.text}
              </Text>
            </ListItem>
          ))}
        </List>
      </VStack>
    </Box>
  );
};

const PricingFeatures = () => {
  const [isAnnual, setIsAnnual] = useState(false);
  const navigate = useNavigate();
  const { setColorMode } = useColorMode();
  const {
    isOpen: isContactOpen,
    onOpen: onContactOpen,
    onClose: onContactClose,
  } = useDisclosure();

  useEffect(() => {
    setColorMode("light");
  }, [setColorMode]);

  const pricingPlans = [
    {
      name: "Growth",
      price: isAnnual ? "₹176" : "₹198",
      period: isAnnual
        ? "per user per month (billed annually)"
        : "per user per month",
      perUser: "Investment starts at ₹8,800/month for 50 users",
      description: "For 20–75 Employees Scaling Fast",
      subtitle: "Automate core HR, payroll, attendance, and compliance without expanding your HR team.",
      icon: FaRocket,
      color: "blue",
      popular: false,
      buttonText: "Start 14-Day Go-Live Sprint",
      features: [
        { text: "Up to 75 employees", included: true },
        { text: "Core HRMS (Employee Database)", included: true },
        { text: "Attendance + Leave Management", included: true },
        { text: "Payroll (India-ready)", included: true },
        { text: "Compliance Templates", included: true },
        { text: "Employee Self-Service Portal", included: true },
        { text: "7-Day Guided Onboarding Sprint", included: true },
        { text: "Migration Support (Basic)", included: true },
        { text: "Standard Reports", included: true },
        { text: "Email Support", included: true },
        { text: "ATS & Recruitment Pipeline", included: false },
        { text: "Advanced Analytics", included: false },
      ],
    },
    {
      name: "Scale",
      price: isAnnual ? "₹264" : "₹290",
      period: isAnnual
        ? "per user per month (billed annually)"
        : "per user per month",
      perUser: "Investment starts at ₹13,200/month for 50 users",
      description: "For 75–200 Employees With Hiring & Complexity",
      subtitle: "Full automation + analytics + AI support for growing organizations.",
      icon: FaCrown,
      color: "purple",
      popular: true,
      buttonText: "Get Started",
      features: [
        { text: "Everything in Growth", included: true },
        { text: "ATS & Recruitment Pipeline", included: true },
        { text: "Role-Based Access Control", included: true },
        { text: "AI HR Assistant", included: true },
        { text: "Advanced Analytics Dashboard", included: true },
        { text: "Audit-Ready Reports", included: true },
        { text: "Compliance Shield Toolkit", included: true },
        { text: "14-Day Go-Live Guarantee", included: true },
        { text: "Priority Support", included: true },
        { text: "50GB Secure Storage", included: true },
        { text: "Performance Management", included: false },
        { text: "Learning Management System", included: false },
      ],
    },
    {
      name: "Enterprise",
      price: "₹352",
      period: "per user per month",
      perUser: "Investment starts at ₹17,600/month for 50 users",
      description: "For 200+ Employees Needing Deep Customization",
      subtitle: "Operational HR backbone with advanced automation and security.",
      icon: FaInfinity,
      color: "orange",
      popular: false,
      buttonText: "Schedule Strategy Call",
      features: [
        { text: "Everything in Scale", included: true },
        { text: "Unlimited Employees", included: true },
        { text: "Performance Management", included: true },
        { text: "Learning Management System", included: true },
        { text: "Custom Workflows & Automation", included: true },
        { text: "API Access", included: true },
        { text: "Custom Integrations", included: true },
        { text: "AI Attrition Insights", included: true },
        { text: "White-Label Option", included: true },
        { text: "Dedicated Account Manager", included: true },
        { text: "24/7 Premium Support", included: true },
        { text: "On-Premise Deployment Option", included: true },
      ],
    },
  ];

  const coreFeatures = [
    {
      icon: FaUsers,
      title: "Employee Database",
      description:
        "Comprehensive employee profiles with personal info, documents, job history, and more",
      color: "blue",
      comingSoon: false,
    },
    {
      icon: FaCloud,
      title: "Digital File Management",
      description:
        "Secure cloud storage with AI-powered document processing and smart search",
      color: "cyan",
      comingSoon: false,
    },
    {
      icon: FaClipboardCheck,
      title: "ATS Pipeline",
      description:
        "AI-driven candidate matching, automated screening, and streamlined hiring workflows",
      color: "purple",
      comingSoon: false,
    },
    {
      icon: FaPlug,
      title: "Sourcing Integrations",
      description:
        "Connect with 50+ job boards and platforms for automated job posting",
      color: "orange",
      comingSoon: false,
    },
    {
      icon: FaShieldAlt,
      title: "Role-Based Access",
      description:
        "Granular permissions and secure user management for data protection",
      color: "red",
      comingSoon: false,
    },
    {
      icon: FaCalendarDay,
      title: "Attendance & Leave",
      description:
        "Biometric integration, geofencing, shift management, and leave policies",
      color: "green",
      comingSoon: false,
    },
    {
      icon: FaFileInvoiceDollar,
      title: "Payroll & Compliance",
      description:
        "Automated salary processing with TDS, PF, ESI, and Form 16 generation",
      color: "teal",
      comingSoon: false,
    },
    {
      icon: FaChartLine,
      title: "Advanced Analytics",
      description:
        "Real-time dashboards, custom reports, and workforce insights",
      color: "blue",
      comingSoon: false,
    },
    {
      icon: FaRobot,
      title: "AI-Powered Features",
      description:
        "Resume screening, sentiment analysis, and predictive attrition modeling",
      color: "purple",
      comingSoon: false,
    },
    {
      icon: FaCheck,
      title: "Performance Management",
      description:
        "Goals (OKR/KRA), 360° appraisals, continuous feedback, and competency tracking",
      color: "green",
      comingSoon: false,
    },
    {
      icon: FaGraduationCap,
      title: "Learning Management",
      description:
        "SCORM-compliant LMS with courses, certifications, and skill tracking",
      color: "pink",
      comingSoon: true,
    },
    {
      icon: FaMobileAlt,
      title: "Mobile Apps",
      description:
        "iOS & Android apps for employees with self-service capabilities",
      color: "cyan",
      comingSoon: true,
    },
    {
      icon: FaHeadset,
      title: "24/7 Support",
      description:
        "Dedicated support team with priority response for enterprise clients",
      color: "orange",
      comingSoon: false,
    },
    {
      icon: FaDatabase,
      title: "Expense & Travel",
      description:
        "Travel requests, mobile receipt OCR, and expense reimbursement workflows",
      color: "indigo",
      comingSoon: false,
    },
    {
      icon: FaLock,
      title: "Compliance & Legal",
      description:
        "S&E Act records, minimum wages, maternity benefits, and POSH workflows",
      color: "red",
      comingSoon: false,
    },
    {
      icon: FaShieldAlt,
      title: "Exit Management",
      description:
        "Resignation tracking, exit interviews, KT tracking, and F&F payroll",
      color: "gray",
      comingSoon: false,
    },
  ];

  const enterpriseAddOns = [
    {
      title: "Advanced Security",
      features: [
        "SSO & SAML Integration",
        "Data Encryption at Rest",
        "Audit Trails & Compliance",
        "IP Whitelisting",
      ],
      icon: FaLock,
      color: "red",
    },
    {
      title: "Custom Development",
      features: [
        "Custom Modules",
        "API Development",
        "Third-party Integrations",
        "Workflow Automation",
      ],
      icon: FaDatabase,
      color: "blue",
    },
    {
      title: "Global Expansion",
      features: [
        "Multi-currency Support",
        "Multi-language Interface",
        "Regional Compliance",
        "Global Payroll",
      ],
      icon: FaGlobe,
      color: "green",
    },
  ];

  return (
    <Box minH="100vh" bg="gray.50">
      <Navbar onContactClick={onContactOpen} />
      <ContactFormModal isOpen={isContactOpen} onClose={onContactClose} />

      <Box py={16}>
        <Container maxW="container.xl">
          {/* Hero Section */}
          <VStack spacing={8} textAlign="center" mb={24}>
         
            <Heading
              as="h1"
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="800"
              lineHeight="1.3"
              maxW="4xl"
              bgGradient="linear(to-r, gray.800, purple.600)"
              bgClip="text"
            >
              Fully Automated, Compliance-Safe HR in 14 Days — Without Hiring More HR Staff
            </Heading>
            <VStack spacing={3} maxW="3xl">
              <HStack spacing={3} justify="center" width="full">
                <Icon as={FaCheck} color="green.500" boxSize={5} />
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="gray.700"
                  fontWeight="500"
                >
                  Reduce HR admin time by 60%
                </Text>
              </HStack>
              <HStack spacing={3} justify="center" width="full">
                <Icon as={FaCheck} color="green.500" boxSize={5} />
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="gray.700"
                  fontWeight="500"
                >
                  Cut onboarding time by 70%
                </Text>
              </HStack>
              <HStack spacing={3} justify="center" width="full">
                <Icon as={FaCheck} color="green.500" boxSize={5} />
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="gray.700"
                  fontWeight="500"
                >
                  Eliminate payroll and compliance stress
                </Text>
              </HStack>
            </VStack>
            <Text
              fontSize="md"
              color="gray.600"
              mt={4}
            >
              Transparent per-employee pricing. No hidden costs.
            </Text>

            {/* Annual/Monthly Toggle */}
            <HStack
              spacing={2}
              mt={8}
              p={1}
              bg="gray.100"
              borderRadius="full"
              border="1px solid"
              borderColor="gray.200"
            >
              <Text
                color={!isAnnual ? "white" : "gray.600"}
                fontWeight="600"
                fontSize="sm"
                cursor="pointer"
                onClick={() => setIsAnnual(false)}
                px={6}
                py={3}
                borderRadius="full"
                bgGradient={
                  !isAnnual ? "linear(to-r, purple.500, purple.600)" : "none"
                }
                bg={!isAnnual ? undefined : "transparent"}
                transition="all 0.3s"
                _hover={{ transform: "scale(1.05)" }}
              >
                Monthly Billing
              </Text>
              <Text
                color={isAnnual ? "white" : "gray.600"}
                fontWeight="600"
                fontSize="sm"
                cursor="pointer"
                onClick={() => setIsAnnual(true)}
                px={6}
                py={3}
                borderRadius="full"
                bgGradient={
                  isAnnual ? "linear(to-r, purple.500, purple.600)" : "none"
                }
                bg={isAnnual ? undefined : "transparent"}
                transition="all 0.3s"
                _hover={{ transform: "scale(1.05)" }}
              >
                Annual Billing
                {isAnnual && (
                  <Badge ml={2} colorScheme="green" fontSize="xx-small">
                    Save 17%
                  </Badge>
                )}
              </Text>
            </HStack>
          </VStack>

          {/* Value Proposition Strip - Why Companies Switch */}
          <Box
            bgGradient="linear(to-br, gray.50, purple.50)"
            p={12}
            rounded="lg"
            border="1px solid"
            borderColor="gray.200"
            mb={20}
          >
            <VStack spacing={8}>
              <VStack spacing={2} textAlign="center">
                <Heading
                  as="h3"
                  fontSize={{ base: "lg", md: "xl" }}
                  color="gray.900"
                  fontWeight="700"
                >
                  Why Companies Switch to NoraHuman
                </Heading>
                <Text color="gray.600" fontSize="sm">
                  Solve the core problems keeping you up at night
                </Text>
              </VStack>

              <Grid
                templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
                gap={6}
                width="full"
              >
                <HStack spacing={4} align="flex-start">
                  <Icon as={FaCheck} color="green.600" boxSize={6} mt={1} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="600" color="gray.800">Zero payroll stress</Text>
                    <Text fontSize="sm" color="gray.600">Automated calculations, tax compliance, on-time payroll</Text>
                  </VStack>
                </HStack>

                <HStack spacing={4} align="flex-start">
                  <Icon as={FaCheck} color="green.600" boxSize={6} mt={1} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="600" color="gray.800">Zero compliance anxiety</Text>
                    <Text fontSize="sm" color="gray.600">Auto-updates for regulations, audit-ready reports</Text>
                  </VStack>
                </HStack>

                <HStack spacing={4} align="flex-start">
                  <Icon as={FaCheck} color="green.600" boxSize={6} mt={1} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="600" color="gray.800">Go live in 14 days</Text>
                    <Text fontSize="sm" color="gray.600">Rapid deployment, zero disruption to operations</Text>
                  </VStack>
                </HStack>

                <HStack spacing={4} align="flex-start">
                  <Icon as={FaCheck} color="green.600" boxSize={6} mt={1} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="600" color="gray.800">90% HR automation</Text>
                    <Text fontSize="sm" color="gray.600">Eliminate manual data entry and repetitive tasks</Text>
                  </VStack>
                </HStack>

                <HStack spacing={4} align="flex-start">
                  <Icon as={FaCheck} color="green.600" boxSize={6} mt={1} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="600" color="gray.800">Real-time workforce visibility</Text>
                    <Text fontSize="sm" color="gray.600">Dashboards, analytics, and actionable insights</Text>
                  </VStack>
                </HStack>

                <HStack spacing={4} align="flex-start">
                  <Icon as={FaCheck} color="green.600" boxSize={6} mt={1} />
                  <VStack align="start" spacing={0}>
                    <Text fontWeight="600" color="gray.800">No additional HR headcount</Text>
                    <Text fontSize="sm" color="gray.600">Scale operations without hiring more HR staff</Text>
                  </VStack>
                </HStack>
              </Grid>
            </VStack>
          </Box>
          <Grid
            id="pricing"
            templateColumns={{
              base: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
            }}
            gap={8}
            mb={12}
          >
            {pricingPlans.map((plan, idx) => (
              <PricingCard
                key={idx}
                {...plan}
                onSelect={() => {
                  if (plan.name === "Enterprise") {
                    onContactOpen();
                  } else {
                    window.location.href = "/login";
                  }
                }}
              />
            ))}
          </Grid>

          {/* Risk Reversal / Guarantee Section */}
          <Box
            bg="linear-gradient(135deg, green.50, emerald.50)"
            p={8}
            rounded="2xl"
            border="2px solid"
            borderColor="green.200"
            mb={20}
            textAlign="center"
          >
            <VStack spacing={4}>
              <HStack justify="center" spacing={3}>
                <Icon as={FaShieldAlt} boxSize={6} color="green.600" />
                <Heading size="md" color="gray.800">
                  30-Day Performance Guarantee
                </Heading>
              </HStack>
              <Grid
                templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
                gap={4}
                width="full"
                maxW="3xl"
              >
                <VStack align="start" spacing={2}>
                  <HStack>
                    <Icon as={FaCheck} color="green.600" />
                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                      Go live in 14 days or we continue assisting free
                    </Text>
                  </HStack>
                  <HStack>
                    <Icon as={FaCheck} color="green.600" />
                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                      Migration failure = full refund
                    </Text>
                  </HStack>
                </VStack>
                <VStack align="start" spacing={2}>
                  <HStack>
                    <Icon as={FaCheck} color="green.600" />
                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                      SLA-backed uptime guarantee
                    </Text>
                  </HStack>
                  <HStack>
                    <Icon as={FaCheck} color="green.600" />
                    <Text fontSize="sm" color="gray.700" fontWeight="500">
                      No lock-in contracts
                    </Text>
                  </HStack>
                </VStack>
              </Grid>
            </VStack>
          </Box>

          {/* Go-Live Timeline */}
          <Box mb={20} bg="white" p={12} rounded="lg" border="1px solid" borderColor="gray.200">
            <VStack spacing={8} textAlign="center" mb={12}>
              <Badge
                bgGradient="linear(to-r, green.500, green.600)"
                color="white"
                px={5}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="700"
                textTransform="uppercase"
                letterSpacing="wider"
              >
                Implementation Timeline
              </Badge>
              <Heading as="h2" fontSize={{ base: "xl", md: "2xl" }} color="gray.900" fontWeight="700">
                Go Live in 14 Days
              </Heading>
            </VStack>

            <Grid
              templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
              gap={8}
              maxW="3xl"
              mx="auto"
            >
              <Box
                bg="blue.50"
                p={6}
                rounded="lg"
                border="2px solid"
                borderColor="blue.200"
              >
                <Heading size="sm" color="blue.800" mb={4} fontSize="lg" fontWeight="700">
                  Week 1
                </Heading>
                <VStack align="start" spacing={2}>
                  <HStack>
                    <Icon as={FaCheck} color="blue.600" />
                    <Text color="gray.700" fontSize="sm">Data migration from existing system</Text>
                  </HStack>
                  <HStack>
                    <Icon as={FaCheck} color="blue.600" />
                    <Text color="gray.700" fontSize="sm">Policy setup & configurations</Text>
                  </HStack>
                  <HStack>
                    <Icon as={FaCheck} color="blue.600" />
                    <Text color="gray.700" fontSize="sm">Payroll & compliance setup</Text>
                  </HStack>
                </VStack>
              </Box>

              <Box
                bg="purple.50"
                p={6}
                rounded="lg"
                border="2px solid"
                borderColor="purple.200"
              >
                <Heading size="sm" color="purple.800" mb={4} fontSize="lg" fontWeight="700">
                  Week 2
                </Heading>
                <VStack align="start" spacing={2}>
                  <HStack>
                    <Icon as={FaCheck} color="purple.600" />
                    <Text color="gray.700" fontSize="sm">Employee rollout & access</Text>
                  </HStack>
                  <HStack>
                    <Icon as={FaCheck} color="purple.600" />
                    <Text color="gray.700" fontSize="sm">Training & HR team enablement</Text>
                  </HStack>
                  <HStack>
                    <Icon as={FaCheck} color="purple.600" />
                    <Text color="gray.700" fontSize="sm">Automation activation & go-live</Text>
                  </HStack>
                </VStack>
              </Box>
            </Grid>
          </Box>

          {/* Core Features Section */}
          <Box
            id="features"
            mb={20}
            bg="white"
            p={12}
            rounded="lg"
            border="1px solid"
            borderColor="gray.200"
          >
            <VStack spacing={4} mb={12} textAlign="center">
              <Badge
                bgGradient="linear(to-r, blue.500, blue.600)"
                color="white"
                px={5}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="700"
                textTransform="uppercase"
                letterSpacing="wider"
              >
                Core Features
              </Badge>
              <Heading
                as="h2"
                fontSize={{ base: "xl", md: "2xl" }}
                color="gray.900"
                fontWeight="700"
              >
                Everything Required to Automate HR End-to-End
              </Heading>
              <Text fontSize="md" color="gray.600" maxW="3xl">
                Designed to eliminate manual HR operations and compliance risk
              </Text>
            </VStack>

            <Grid
              templateColumns={{
                base: "1fr",
                md: "repeat(2, 1fr)",
                lg: "repeat(3, 1fr)",
              }}
              gap={6}
            >
              {coreFeatures.map((feature, idx) => (
                <FeatureCard key={idx} {...feature} />
              ))}
            </Grid>
          </Box>

          {/* Enterprise Add-ons */}
          <Box
            id="enterprise"
            mb={20}
            bg="white"
            p={12}
            rounded="lg"
            border="1px solid"
            borderColor="gray.200"
          >
            <VStack spacing={4} mb={12} textAlign="center">
              <Badge
                bgGradient="linear(to-r, orange.500, orange.600)"
                color="white"
                px={5}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="700"
                textTransform="uppercase"
                letterSpacing="wider"
              >
                Enterprise Solutions
              </Badge>
              <Heading
                as="h2"
                fontSize={{ base: "xl", md: "2xl" }}
                color="gray.900"
                fontWeight="700"
              >
                Advanced Enterprise Capabilities
              </Heading>
            </VStack>

            <Grid
              templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
              gap={6}
            >
              {enterpriseAddOns.map((addon, idx) => (
                <Box
                  key={idx}
                  bg="white"
                  p={6}
                  rounded="lg"
                  border="1px solid"
                  borderColor="gray.200"
                  transition="all 0.2s"
                  _hover={{
                    shadow: "md",
                    borderColor: `${addon.color}.300`,
                  }}
                >
                  <Circle
                    size="50px"
                    bg={`${addon.color}.50`}
                    color={`${addon.color}.600`}
                    mb={4}
                  >
                    <Icon as={addon.icon} boxSize={6} />
                  </Circle>
                  <Heading size="md" color="gray.800" mb={4} fontWeight="600">
                    {addon.title}
                  </Heading>
                  <List spacing={2}>
                    {addon.features.map((feature, fIdx) => (
                      <ListItem key={fIdx} display="flex" alignItems="center">
                        <ListIcon as={FaCheck} color={`${addon.color}.500`} />
                        <Text fontSize="sm" color="gray.600">
                          {feature}
                        </Text>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              ))}
            </Grid>
          </Box>

          {/* CTA Section */}
          <Box
            id="contact"
            bgGradient="linear(to-br, gray.900, purple.900)"
            p={20}
            rounded="3xl"
            textAlign="center"
            position="relative"
            overflow="hidden"
            _before={{
              content: '""',
              position: "absolute",
              top: "-50%",
              right: "-50%",
              width: "100%",
              height: "100%",
              bgGradient: "radial(purple.500, transparent)",
              opacity: 0.3,
            }}
          >
            <VStack spacing={8}>
              <Heading
                as="h2"
                fontSize={{ base: "xl", md: "2xl" }}
                color="white"
                fontWeight="700"
              >
                Stop Managing HR. Start Automating It.
              </Heading>
              <Text fontSize="md" color="gray.300" maxW="2xl">
                Founder-friendly pricing. No hidden implementation fees. Go live in 14 days.
              </Text>

              <HStack spacing={4} flexWrap="wrap" justify="center">
                <Button
                  bgGradient="linear(to-r, purple.500, purple.600)"
                  color="white"
                  size="lg"
                  onClick={() => (window.location.href = "/login")}
                  px={10}
                  py={7}
                  fontSize="lg"
                  fontWeight="700"
                  _hover={{
                    bgGradient: "linear(to-r, purple.600, purple.700)",
                    transform: "translateY(-4px)",
                    boxShadow: "2xl",
                  }}
                  transition="all 0.3s"
                >
                  Start 14-Day Go-Live Sprint
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  onClick={onContactOpen}
                  px={10}
                  py={7}
                  fontSize="lg"
                  fontWeight="700"
                  borderWidth="2px"
                  borderColor="white"
                  color="white"
                  _hover={{
                    bg: "white",
                    color: "purple.600",
                    transform: "translateY(-4px)",
                    boxShadow: "2xl",
                  }}
                  transition="all 0.3s"
                >
                  Talk to an HR Automation Specialist
                </Button>
              </HStack>

              <Text fontSize="sm" color="gray.400" mt={4}>
                No credit card required • 14-day onboarding sprint • Cancel anytime
              </Text>
            </VStack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default PricingFeatures;
